import React from "react";
import { Helmet } from "react-helmet-async";

export default function PageHelmet(props) {
    return (
        <Helmet>
            <title>{props.title} - Barnes Specialty Gases</title>
        </Helmet>
    )
}